export default "__VITE_ASSET__4b49b57f__"